














import { Vue, Component } from 'vue-property-decorator';
import { AccessControlConfigInterface } from '@core/interfaces/access-control-config-interface';
import EnrollmentTable from '@activities/components/tables/enrollment-table/enrollment-table.vue';

@Component({
  name: 'bc-enrollment-payment-follow-up',
  components: {
    'bpc-enrollment-table': EnrollmentTable,
  },
})
export default class EnrollmentPaymentFollowUp extends Vue {
  get extendedFilterConfigName() {
    return 'extended';
  }
}
